import "./footer.css";
import { Link, useLocation } from "react-router-dom";

function Footer() {
    const location = useLocation();

    const imgStyle = { 
        width: '26px', 
        height: '35px', 
        objectFit: 'contain' 
    };

    // GIỮ NGUYÊN 100% DỮ LIỆU NÚT CỦA BẠN
    const data = [
        { 
            title: "Trang Chủ", 
            to: "/", 
            icon: <img src="https://i.ibb.co/YTkSzGYH/gemini-svg-1-removebg-preview.png" alt="icon" style={imgStyle} />,
            iconactive: <img src="https://i.ibb.co/CpGVWxRh/homea-removebg-preview.png" alt="icon" style={imgStyle} />
        },
        { 
            title: "Khuyến Mãi", 
            to: "/notification", 
            icon: <img src="https://i.ibb.co/tpCk5LLR/po-removebg-preview.png" alt="icon" style={imgStyle} />,
            iconactive: <img src="https://i.ibb.co/fdCkW77k/gemini-svg-2-removebg-preview.png" alt="icon" style={imgStyle} />
        },
        { 
            title: "Tải App", 
            to: "#", 
            icon: <img src="https://i.ibb.co/MyNBP6WD/dow-removebg-preview.png" alt="icon" style={imgStyle} />,
            iconactive: <img src="https://i.ibb.co/MyNBP6WD/dow-removebg-preview.png" alt="icon" style={imgStyle} />
        },
        { 
            title: "CSKH", 
            to: "/service", 
            icon: <img src="https://i.ibb.co/9kH7d9DL/hot-removebg-preview.png" alt="icon" style={imgStyle} />,
            iconactive: <img src={require('../../images/moi/b43455ae-dc20-4c52-9f84-f167caeab966.jpg')} alt="icon" style={imgStyle} />
        },
        { 
            title: "Tài khoản", 
            to: "/profile", 
            icon: <img src="https://i.ibb.co/b5JPtRZJ/t-i-xu-ng-1-removebg-preview.png" alt="icon" style={imgStyle} />,
            iconactive: <img src="https://i.ibb.co/b5JPtRZJ/t-i-xu-ng-1-removebg-preview.png" alt="icon" style={imgStyle} />
        }
    ];

    return (
        <>
            {/* Cập nhật CSS hiển thị nền xanh ngọc và màu chữ */}
            <style dangerouslySetInnerHTML={{__html: `
                .new-footer-bg {
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    max-width: 540px; /* Khớp với giao diện mobile app hiện tại */
                    height: 77px;
                    background: #6dd8bd; /* Nền xanh ngọc y như ảnh */
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    z-index: 9999;
                    box-shadow: 0 -2px 5px rgba(0,0,0,0.1);
                }
                .new-footer-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-decoration: none;
                    height: 100%;
                }
                .new-footer-text {
                    font-size: 11px;
                    font-weight: 700;
                    color: #1a6544; /* Màu chữ mặc định (xanh đậm) */
                    margin-top: 3px;
                    white-space: nowrap;
                    transition: color 0.2s;
                }
                .new-footer-text.active {
                    color: #00ffaa; /* Màu chữ sáng (neon) khi được chọn */
                }
                .new-footer-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: transform 0.2s;
                }
                .new-footer-item:active .new-footer-icon {
                    transform: scale(0.85); /* Hiệu ứng bấm lún xuống nhẹ */
                }
            `}} />

            <div className="new-footer-bg">
                {data.map((item, index) => {
                    const isActive = location.pathname === item.to || (item.to !== "/" && location.pathname.startsWith(item.to));
                    return (
                        <Link key={index} style={{ textDecoration: "none" }} to={item.to} className="new-footer-item">
                            <div className="new-footer-icon">
                                {isActive ? item.iconactive : item.icon}
                            </div>
                            <div className={`new-footer-text ${isActive ? "active" : ""}`}>
                                {item.title}
                            </div>
                        </Link>
                    );
                })}
            </div>
        </>
    );
}

export default Footer;